import type {PropsWithChildren} from 'react';
import clsx from 'clsx';

import {Link} from '@/modules/foundation/components/link';

type Props = PropsWithChildren & {
	href?: string;
	targetBlank?: boolean;
};

export const PortableLink = ({children, href, targetBlank}: Props) => {
	return (
		<Link
			href={href}
			targetBlank={targetBlank}
			className={clsx(
				'text-primary',
				'hover:text-secondary-dm',
				'underline-offset-4',
				'hover:no-underline',
				'transition-colors',
			)}
		>
			{children}
		</Link>
	);
};
